import { Card, Radio, TextField, Typography } from '@mui/material';
import { ReactElement } from 'react';
import styled from 'styled-components';

const CustomCardWrap = styled(Card)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid #999;
  .title{
    padding: 0.5rem 1rem;
    width: 100%;
    display:flex;
    justify-content: space-between;
    background:rgba(82, 133, 164, 0.87);
    color: #ffffff;
  }
  .body{
    flex-grow: 1;
    padding: 1rem;
    width: 100%;
    height: 100%;
    overflow:hidden;
  }
`;

export function CustomCard({ children, title, opt }: { children: ReactElement; title: string; opt?: any[] }) {
  return (
    <CustomCardWrap>
      <div className="title">
        <Typography variant="h6">{title}</Typography>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          {opt?.map((item, index) => {
            return (
              <>
                {index > 0 && <>&nbsp;&nbsp;</>}
                {item}
              </>
            );
          })}
        </div>
      </div>
      <div className="body">{children}</div>
    </CustomCardWrap>
  );
}

export const CustomTextField = styled(TextField)`
  & label {
    color: #888;
  }
  & label.Mui-focused {
    color: #888;
  }
  & .notchedOutline {
    border-color: #888;
  }
  & .MuiOutlinedInput-root {
    color: #333;
    & fieldset {
      border-color: #888;
    }
    &.Mui-focused fieldset {
      border-color: #888;
    }
    &:hover fieldset {
      border-color: #888;
    }
  }
    
`;

export const CustomRadio = styled(Radio)`
  color: #888;
  &.Mui-checked{
  color: #888;
  }
`;
